import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";

const breadcrumbStatic = [{
	name: 'Schedule Adjustments',
	url: '/schedule_adjust',
	icon: 'clipboard'
}];

export default class Time_Offs extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history, roles, user, main_role} = this.props;
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}>
					<Button data-cy="add-timeoff" onClick={this.toggle('modalTimeOff')} size={"sm"} color="primary">
						Schedule Adjust
					</Button>
				</Framework.Components.PageBar>
				<div className={"row"}>
					<div className={"col"}>
						<Collections.TimeOff
							history={history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={roles.includes(UserRoles.Admin)}
							user={user}
							main_role={main_role}
						/>
					</div>
				</div>

				<Framework.Elements.UniversalModal
					title={"Schedule Adjust for Bonus Eligibility"}
					object={Objects.TimeOffRequest}
					history={history}
					toggle={this.state.modalTimeOff}
					reportClose={this.reportClose('modalTimeOff')}
					afterSave={() => this.setState({refresh: !this.state.refresh, modalTimeOff: false})}
					size={'md'}
					objectProps={{main_role: main_role}}
					submitLabel={"Submit"}
				/>
			</div>
		)
	}
}